import styles from './LinearProgressBar.scss';

import cn from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';

import checkIcon from 'src/images/icons/check-280.svg';

import { ProgressBarProps } from '../ResponsiveProgressBar';

export const Step = ({ isActive, isCompleted, title }: { isActive: boolean; isCompleted: boolean; title: string }) => {
  const { t } = useTranslation();
  return (
    <li className={cn(styles.step, { [styles.stepActive]: isActive, [styles.stepCompleted]: isCompleted })}>
      <div className={styles.progress}>
        {
          isCompleted ? (
            <img src={checkIcon} alt="completed" />
          )
          :
          <span />
        }
      </div>
      <h5 className={styles.label}>{t(title as any)}</h5>
    </li>
  );
};

export const LinearProgressBar: React.FC<ProgressBarProps> = ({
  steps,
  currentStep,
}) => {
  return (
    <div className={styles.linearProgressBar}>
      <ol className={styles.steps}>
        { steps.map((step, index) => (
          <Step
            key={index}
            title={step.title}
            isActive={index === currentStep - 1}
            isCompleted={index < currentStep - 1}
          />
        ))}
      </ol>
    </div>
  );
};
